import { defineNuxtPlugin } from "#app";
import { mapValues } from "radash";

import { getEnv, useGlobal } from "@solvari/utils";

import { useZiggy } from "~/app/api/routing.api.ts";
import { toInternalUrl } from "~/shared/composables/useHost.ts";
import { useQueryAsync } from "~/shared/libs/useQueryAsync.ts";
import { resolveZiggyRouteDomain } from "~/shared/libs/ziggyProxyRewrite.ts";

export default defineNuxtPlugin(async () => {
  const result = await useQueryAsync(
    useZiggy({ group: "main-site", locale: getEnv().config.localeCode }),
  );

  if (result instanceof Error) {
    throw new Error("Failed to load ziggy");
  }

  const proxyBase = toInternalUrl(`/cache-proxy/api`);

  const ziggyData = {
    ...result,
    routes: mapValues(result.routes, (route) => {
      const domain = resolveZiggyRouteDomain(route, proxyBase);
      return { ...route, domain };
    }),
  };

  useGlobal<typeof ziggyData>("Ziggy").set(ziggyData);
});
